import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

import { getPromotionPlanType } from '../../../components/PromotionModal/PromotionModal';
import { formatDateWithProximity } from '../../../util/dates';
import { PROMOTION_TYPE } from '../../../constants/payment.constants';

import css from './ManageListingCard.module.css';

const ListingPromotion = props => {
  const intl = useIntl();

  const { currentListing } = props;
  const { metadata } = currentListing?.attributes || {};

  const { promotionPlan, boostedAt } = metadata || {};

  if (!promotionPlan && !boostedAt) return null;

  const type = getPromotionPlanType(promotionPlan);

  const isRecommendedActive = [
    PROMOTION_TYPE.RECURRING.RECOMMENDED,
    PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
  ].includes(type);

  const isHighlightActive = [
    PROMOTION_TYPE.RECURRING.HIGHLIGHT,
    PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
  ].includes(type);

  const labelRecommended = isRecommendedActive && (
    <FormattedMessage id="General.listing.promotion.recommended" />
  );
  const labelHighlight = isHighlightActive && (
    <FormattedMessage id="General.listing.promotion.highlighted" />
  );

  const labelBoosted = boostedAt && (
    <FormattedMessage
      id="ListingPromotion.boostedAgo"
      values={{
        ago: formatDateWithProximity(
          new Date(boostedAt),
          intl,
          intl.formatMessage({ id: 'ListingPromotion.today' })
        ),
      }}
    />
  );

  return (
    <div className={css.promotions}>
      {labelRecommended && (
        <span className={classNames(css.label, css.promotionRecommended)}>{labelRecommended}</span>
      )}
      {labelHighlight && (
        <span className={classNames(css.label, css.promotionHighlight)}>{labelHighlight}</span>
      )}
      {labelBoosted && (
        <span className={classNames(css.label, css.promotionBoosted)}>{labelBoosted}</span>
      )}
    </div>
  );
};

export default ListingPromotion;
